"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getUserPhotoUrl = exports.getUserUrl = exports.searchUsersUrl = void 0;

var _getMsGraphResourceName = require("../getMsGraphResourceName");

var _getMsGraphUrl = require("../getMsGraphUrl");

var getV1MsGraphUrl = (0, _getMsGraphUrl.getMsGraphUrl)('v1.0');

var searchUsersUrl = function searchUsersUrl(search, top) {
  var usersUrl = getV1MsGraphUrl('/users');
  usersUrl.searchParams.set('$top', top.toString());
  return {
    method: 'GET',
    url: usersUrl.toString() + "&$filter=startsWith(displayName, '".concat(encodeURIComponent(search), "')"),
    audience: (0, _getMsGraphResourceName.getMsGraphResourceName)()
  };
};

exports.searchUsersUrl = searchUsersUrl;

var getUserUrl = function getUserUrl(id) {
  var usersUrl = getV1MsGraphUrl("/users/".concat(encodeURIComponent(id)));
  return {
    url: usersUrl.toString(),
    audience: (0, _getMsGraphResourceName.getMsGraphResourceName)()
  };
};

exports.getUserUrl = getUserUrl;

var getUserPhotoUrl = function getUserPhotoUrl(id) {
  var usersUrl = getV1MsGraphUrl("/users/".concat(encodeURIComponent(id), "/photo/$value"));
  return {
    method: 'GET',
    url: usersUrl.toString(),
    audience: (0, _getMsGraphResourceName.getMsGraphResourceName)()
  };
};

exports.getUserPhotoUrl = getUserPhotoUrl;